import { SvgIcon } from 'ui/icons';

export const SavedViews = () => {
  return (
    <SvgIcon width="297" height="297" viewBox="0 0 297 297">
      <g clipPath="url(#clip0_391_96529)">
        <path
          d="M268.333 166.335C268.331 148.637 264.368 131.163 256.735 115.196C249.102 99.2279 237.992 85.171 224.22 74.0555C210.448 62.94 194.363 55.0477 177.144 50.9572C159.924 46.8668 142.008 46.6819 124.708 50.4161C107.409 54.1504 91.1638 61.7091 77.1652 72.5381C63.1665 83.3671 51.7689 97.1917 43.8081 112.998C35.8472 128.805 31.5248 146.193 31.158 163.888C30.7911 181.582 34.389 199.134 41.6879 215.257H257.777C264.749 199.891 268.348 183.209 268.333 166.335Z"
          fill="#F5F4F4"
        />
        <path
          d="M32.615 215.258H263.885"
          stroke="#6A266D"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.2725 215.258H26.685"
          stroke="#6A266D"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M269.815 215.258H277.228"
          stroke="#6A266D"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M266.387 239.748C266.387 242.796 218.349 245.539 158.652 245.539C98.9546 245.539 50.9609 242.948 50.9609 239.748C50.9609 236.548 98.9983 233.957 158.652 233.957C218.306 233.957 266.387 236.7 266.387 239.748Z"
          fill="#F5F4F4"
        />
        <path d="M137.232 206.383H163.641V222.23H137.232V206.383Z" fill="white" />
        <path
          d="M137.232 206.383H163.641V222.23H137.232V206.383Z"
          stroke="#6A266D"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M184.771 232.793H116.105C116.105 231.405 116.378 230.03 116.909 228.748C117.441 227.465 118.219 226.3 119.201 225.319C120.182 224.337 121.348 223.558 122.63 223.027C123.912 222.496 125.287 222.223 126.675 222.223H174.214C177.015 222.226 179.7 223.341 181.68 225.323C183.659 227.305 184.771 229.992 184.771 232.793Z"
          fill="white"
          stroke="#6A266D"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M232.31 98.098C232.31 96.3638 231.969 94.6464 231.306 93.044C230.642 91.4416 229.67 89.9856 228.443 88.7592C227.217 87.5327 225.761 86.5598 224.159 85.896C222.557 85.2323 220.84 84.8906 219.105 84.8906H81.7703C80.036 84.8906 78.3187 85.2323 76.7164 85.896C75.1142 86.5598 73.6584 87.5327 72.4322 88.7592C71.206 89.9856 70.2334 91.4416 69.5699 93.044C68.9065 94.6464 68.5652 96.3638 68.5656 98.098V185.254H232.31V98.098Z"
          fill="#E6FFF7"
        />
        <path
          d="M232.31 98.098C232.31 96.3638 231.969 94.6464 231.306 93.044C230.642 91.4416 229.67 89.9856 228.443 88.7592C227.217 87.5327 225.761 86.5598 224.159 85.896C222.557 85.2323 220.84 84.8906 219.105 84.8906H81.7703C80.036 84.8906 78.3187 85.2323 76.7164 85.896C75.1142 86.5598 73.6584 87.5327 72.4322 88.7592C71.206 89.9856 70.2334 91.4416 69.5699 93.044C68.9065 94.6464 68.5652 96.3638 68.5656 98.098V185.254H232.31V98.098Z"
          stroke="#6A266D"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M219.105 206.381C220.839 206.381 222.556 206.039 224.159 205.376C225.761 204.712 227.216 203.74 228.442 202.513C229.669 201.287 230.641 199.831 231.305 198.229C231.968 196.627 232.31 194.91 232.31 193.176V185.254H68.5656V193.176C68.5656 196.678 69.9568 200.037 72.4331 202.513C74.9095 204.99 78.2682 206.381 81.7703 206.381H219.105Z"
          fill="white"
          stroke="#6A266D"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M148.58 197.678C148.086 197.185 147.809 196.516 147.809 195.818C147.809 195.12 148.086 194.451 148.58 193.958C149.073 193.465 149.742 193.188 150.44 193.188C151.137 193.188 151.806 193.465 152.3 193.958C152.793 194.451 153.07 195.12 153.07 195.818C153.07 196.516 152.793 197.185 152.3 197.678C151.806 198.171 151.137 198.448 150.44 198.448C149.742 198.448 149.073 198.171 148.58 197.678Z"
          fill="#6A266D"
          stroke="#6A266D"
        />
        <path
          d="M84.4374 97.2891H216.438V115.836H84.4374V97.2891Z"
          fill="white"
          stroke="#6A266D"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M216.438 185.254H179.307V129.245C179.307 128.527 179.592 127.837 180.101 127.329C180.609 126.821 181.298 126.535 182.017 126.535H213.728C214.447 126.535 215.136 126.821 215.644 127.329C216.153 127.837 216.438 128.527 216.438 129.245V185.254Z"
          fill="white"
          stroke="#6A266D"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M84.4374 126.535H166.953V145.082H84.4374V126.535Z"
          fill="white"
          stroke="#6A266D"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M132.475 155.777H166.956V174.324H132.475V155.777Z"
          fill="white"
          stroke="#6A266D"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M84.4374 155.777H118.918V174.324H84.4374V155.777Z"
          fill="white"
          stroke="#6A266D"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M54.5577 161.832C54.5577 160.727 55.4531 159.832 56.5577 159.832H90.3615C91.466 159.832 92.3615 160.727 92.3615 161.832V227.139C92.3615 228.243 91.466 229.139 90.3615 229.139H56.5577C55.4531 229.139 54.5577 228.243 54.5577 227.139V161.832Z"
          fill="white"
        />
        <path
          d="M54.5577 161.832C54.5577 160.727 55.4531 159.832 56.5577 159.832H90.3615C91.466 159.832 92.3615 160.727 92.3615 161.832V227.139C92.3615 228.243 91.466 229.139 90.3615 229.139H56.5577C55.4531 229.139 54.5577 228.243 54.5577 227.139V161.832Z"
          stroke="#6A266D"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M54.5577 167.707H92.3615V221.261H54.5577V167.707Z" fill="#E6FBFF" />
        <path
          d="M84.1779 178.526C84.1783 179.022 84.081 179.512 83.8916 179.97C83.7022 180.428 83.4244 180.844 83.0741 181.194C82.7238 181.544 82.3079 181.822 81.8501 182.012C81.3924 182.201 80.9018 182.298 80.4064 182.298H66.5124C65.5308 182.27 64.5987 181.861 63.9142 181.157C63.2296 180.453 62.8467 179.51 62.8467 178.528C62.8467 177.546 63.2296 176.603 63.9142 175.899C64.5987 175.195 65.5308 174.785 66.5124 174.758H80.4064C80.9015 174.757 81.3919 174.855 81.8495 175.044C82.307 175.233 82.7228 175.511 83.0731 175.861C83.4233 176.211 83.7012 176.626 83.8907 177.083C84.0803 177.541 84.1779 178.031 84.1779 178.526Z"
          fill="white"
          stroke="#6A266D"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M62.744 190.715H84.178V213.978H62.744V190.715Z"
          fill="white"
          stroke="#6A266D"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M54.5577 167.707H92.3615V221.261H54.5577V167.707Z"
          stroke="#6A266D"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M187.325 136.352C187.325 135.247 188.221 134.352 189.325 134.352H260.693C261.797 134.352 262.693 135.247 262.693 136.352V228.305C262.693 229.409 261.797 230.305 260.693 230.305H189.325C188.221 230.305 187.325 229.409 187.325 228.305V136.352Z"
          fill="white"
          stroke="#6A266D"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M196.149 146.645H253.871V218.015H196.149V146.645Z"
          fill="#FFF8D9"
          stroke="#6A266D"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M204.638 155.398H245.38V168.201H204.638V155.398Z"
          fill="white"
          stroke="#6A266D"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M233.297 175.926H245.38V209.258H233.297V175.926Z"
          fill="white"
          stroke="#6A266D"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M204.638 175.926H225.01V188.729H204.638V175.926Z"
          fill="white"
          stroke="#6A266D"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M204.638 196.457H225.01V209.26H204.638V196.457Z"
          fill="white"
          stroke="#6A266D"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <mask id="path-30-inside-1_391_96529" fill="white">
          <path d="M79.26 100H80.07C80.1805 100 80.27 100.09 80.27 100.2V100.7C80.27 100.866 80.1357 101 79.97 101H79.26V100Z" />
        </mask>
        <path
          d="M79.26 100H80.07C80.1805 100 80.27 100.09 80.27 100.2V100.7C80.27 100.866 80.1357 101 79.97 101H79.26V100Z"
          fill="#6A266D"
          stroke="#6A266D"
          mask="url(#path-30-inside-1_391_96529)"
        />
      </g>
      <path
        d="M237.299 173.637L246.582 166.319L255.117 177.145L245.834 184.463L237.299 173.637Z"
        fill="white"
        stroke="#6A266D"
        strokeWidth="1.28"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M272.469 197.103C273.815 198.739 274.464 200.793 274.271 202.813C274.079 204.833 273.061 206.653 271.443 207.874C269.825 209.094 267.738 209.614 265.642 209.319C263.546 209.025 261.612 207.94 260.266 206.304L245.042 187.79C244.706 187.381 244.544 186.867 244.592 186.362C244.64 185.857 244.894 185.402 245.299 185.097L254.45 178.197C254.855 177.892 255.377 177.762 255.901 177.836C256.425 177.909 256.908 178.18 257.245 178.589L272.469 197.103Z"
        fill="#B56DC6"
        stroke="#6A266D"
        strokeWidth="1.28"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M187.783 122.281C185.35 126.496 183.77 131.149 183.135 135.974C182.5 140.8 182.821 145.703 184.081 150.404C185.341 155.106 187.514 159.513 190.477 163.374C193.44 167.235 197.134 170.475 201.349 172.909C205.564 175.343 210.217 176.922 215.043 177.557C219.868 178.193 224.772 177.871 229.473 176.612C234.174 175.352 238.581 173.178 242.443 170.216C246.304 167.253 249.544 163.558 251.978 159.343C254.411 155.128 255.991 150.475 256.626 145.65C257.261 140.824 256.94 135.921 255.68 131.219C254.42 126.518 252.247 122.111 249.284 118.25C246.321 114.388 242.627 111.148 238.412 108.715C234.197 106.281 229.544 104.702 224.718 104.066C219.893 103.431 214.989 103.753 210.288 105.012C205.587 106.272 201.18 108.445 197.318 111.408C193.457 114.371 190.217 118.066 187.783 122.281Z"
        fill="white"
        stroke="#6A266D"
        strokeWidth="1.28"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M191.159 130.32C188.368 137.893 188.699 146.264 192.08 153.592C195.461 160.92 201.613 166.604 209.185 169.395C216.757 172.185 225.127 171.853 232.454 168.471C239.781 165.089 245.466 158.935 248.257 151.361C251.047 143.788 250.716 135.417 247.336 128.089C243.955 120.761 237.802 115.077 230.231 112.286C222.659 109.496 214.289 109.829 206.962 113.21C199.634 116.592 193.95 122.747 191.159 130.32Z"
        fill="#E6FBFF"
        stroke="#6A266D"
        strokeWidth="1.28"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <clipPath id="clip0_391_96529">
          <rect width="296.5" height="296.5" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};
